import htmlDecode from './html-decode'

function findFloatingLabel(id: string): Element | null {
	let dom = document.querySelector(id)
	if (dom) {
		let nextSibling = dom.nextSibling
		while (
			(nextSibling && nextSibling.nodeType !== 1) ||
			(nextSibling &&
				(nextSibling as Element).getAttribute('class') !== 'Form__FloatingLabel')
		) {
			nextSibling = nextSibling.nextSibling
		}

		return nextSibling as Element | null
	}

	return null
}

function dynamicDeliveryForm(deliveryType: string) {
	const rowItemFirstName = $('#shipping-address-wrapper')
		.find('#firstName')
		.parent()
	const rowItemLastName = $('#shipping-address-wrapper')
		.find('#lastName')
		.parent()
	const rowItemAddress1 = $('#shipping-address-wrapper')
		.find('#address1')
		.parent()
	const rowItemAddress2 = $('#shipping-address-wrapper')
		.find('#address2')
		.parent()
	const rowItemCountry = $('#shipping-address-wrapper')
		.find('#countryId')
		.parent()
	const rowItemZip = $('#shipping-address-wrapper').find('#zip').parent()
	const rowItemState = $('#shipping-address-wrapper').find('#stateId').parent()
	const rowItemCity = $('#shipping-address-wrapper').find('#city').parent()
	const rowItemPhone = $('#shipping-address-wrapper').find('#phone').parent()
	// const rowItemEmail = $('#shipping-address-wrapper').find('#email').parent()
	const deliverHeader__label = document.querySelector('#deliverHeader__label')
	// const emailBilling = document.querySelector('#emailBilling')
	// const emailBillingFloatLabel = findFloatingLabel('#emailBilling')
	const emailShipping = document.querySelector('#email')
	const emailField__changeLabel__shipping = document.querySelector('.emailField__changeLabel__shipping')
	const emailShippingFloatLabel = findFloatingLabel('#email')

	// alert(window.myvars.dynamicDeliveryAddressForm)

	// const sameAsShipping = $("#sameAsShipping:checked") === true
	// document.getElementById('sameAsShipping').checked === true
	// debugger

	switch (deliveryType) {
		case 'shipping':
		case 'collect_on_delivery':
			if (window.myvars.dynamicDeliveryAddressForm === 'listOptional') {
				// if (window.twStore) {
				// 	rowItemCountry.show()
				// 	rowItemState.hide()
				// 	rowItemZip.show()
				// 	rowItemCity.show()
				// 	rowItemAddress1.show()
				// 	rowItemAddress2.hide()
				// } else {
					$('#address1').attr('placeholder', htmlDecode(window.myvars.address1))

					$('#address1')
						.siblings('.Form__FloatingLabel')
						.html(window.myvars.address1)

					$('#address2').attr('placeholder', htmlDecode(window.myvars.address2))

					$('#address2')
						.siblings('.Form__FloatingLabel')
						.html(window.myvars.address2)

					$('#countryId')
						.siblings('.Form__FloatingLabel')
						.html(window.myvars.country)

					$('#zip').attr('placeholder', htmlDecode(window.myvars.zip))
					$('#zip').siblings('.Form__FloatingLabel').html(window.myvars.zip)

					$('#stateId').siblings('.Form__FloatingLabel').html(window.myvars.state)

					$('#city').attr('placeholder', htmlDecode(window.myvars.city))
					$('#city').siblings('.Form__FloatingLabel').html(window.myvars.city)
					$('#phone').attr('placeholder', htmlDecode(window.myvars.phone))
					$('#phone').siblings('.Form__FloatingLabel').html(window.myvars.phone)
				// }
			} else {
				rowItemFirstName.show()
				rowItemLastName.show()
				rowItemAddress1.show()
				rowItemAddress2.show()
				rowItemCountry.show()
				rowItemZip.show()
				rowItemState.show()
				rowItemCity.show()
				rowItemPhone.show()
			}

			if (deliverHeader__label) {
				deliverHeader__label.innerHTML = window.myvars.shippingAddress
			}

			if (emailShipping) {
				emailShipping.setAttribute(
					'placeholder',
					window.myvars.emailForConfirmation
				)
			}

			if (emailShippingFloatLabel) {
				emailShippingFloatLabel.innerHTML = window.myvars.emailForConfirmation
			}

			if (emailField__changeLabel__shipping) {
				emailField__changeLabel__shipping.innerHTML = window.myvars.emailForConfirmation
			}

			break

		case 'willcall':
		case 'pickup':
		case 'eticket':
			if (window.myvars.dynamicDeliveryAddressForm === 'listOptional' && !window.jaStore) {
				$('#address1').attr('placeholder', htmlDecode(window.myvars.address1Optional))

				$('#address1')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.address1Optional)

				$('#address2').attr('placeholder', htmlDecode(window.myvars.address2Optional))
				$('#address2')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.address2Optional)

				$('#countryId')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.countryOptional)

				$('#zip').attr('placeholder', htmlDecode(window.myvars.zipOptional))

				$('#zip')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.zipOptional)


				$('#stateId')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.stateOptional)

				$('#city').attr('placeholder', htmlDecode(window.myvars.cityOptional))

				$('#city')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.cityOptional)
			} else if (window.jaStore) {
				$('#address1').attr('placeholder', htmlDecode(window.myvars.address1))
				// $('#address1').attr('optional', 'true')
				$('#address1')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.address1)

				$('#address2').attr('placeholder', htmlDecode(window.myvars.address2))
				// $('#address2').attr('optional', 'true')
				$('#address2')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.address2)

				// $('#countryId').attr('optional', 'true')
				$('#countryId')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.country)

				$('#zip').attr('placeholder', htmlDecode(window.myvars.zip))
				// $('#zip').attr('optional', 'true')
				$('#zip')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.zip)

				// $('#stateId').attr('optional', 'true')
				$('#stateId')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.state)

				$('#city').attr('placeholder', window.myvars.city)
				// $('#city').attr('optional', 'true')
				$('#city')
					.siblings('.Form__FloatingLabel')
					.html(window.myvars.city)
			// } else if (window.twStore) {
			// 	rowItemAddress1.hide()
			// 	rowItemCountry.hide()
			// 	rowItemZip.hide()
			// 	rowItemState.hide()
			// 	rowItemCity.hide()
			} else {
				// rowItemEmail.show()
				rowItemFirstName.show()
				rowItemLastName.show()
				rowItemPhone.show()

				rowItemAddress1.hide()
				rowItemAddress2.hide()
				rowItemCountry.hide()
				rowItemZip.hide()
				rowItemState.hide()
				rowItemCity.hide()
				// rowItemPhone.hide()
			}

			if (deliverHeader__label) {
				deliverHeader__label.innerHTML = window.myvars.yourDetails
			}

			if (deliveryType === 'eticket') {
				if (emailShipping) {
					emailShipping.setAttribute(
						'placeholder',
						htmlDecode(window.myvars.emailForEticket)
					)
				}

				if (emailShippingFloatLabel) {
					emailShippingFloatLabel.innerHTML = window.myvars.emailForEticket
				}

				if (emailField__changeLabel__shipping) {
					emailField__changeLabel__shipping.innerHTML = window.myvars.emailForEticket
				}
			} else {
				if (emailShipping) {
					emailShipping.setAttribute(
						'placeholder',
						htmlDecode(window.myvars.emailForConfirmation)
					)
				}

				if (emailShippingFloatLabel) {
					emailShippingFloatLabel.innerHTML = window.myvars.emailForConfirmation
				}

				if (emailField__changeLabel__shipping) {
					emailField__changeLabel__shipping.innerHTML = window.myvars.emailForConfirmation
				}

			}

			break

		default:
			break
	}
}

export default dynamicDeliveryForm

window.dynamicDeliveryForm = dynamicDeliveryForm
